import type { IconData } from '@stacksjs/iconify-core'

export const chevronCircleUpLeftF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 9h5a1 1 0 0 0 0-2H8a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0zm1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronCircleUpLeftF
